<script setup lang="ts">
    import { storeToRefs } from 'pinia';

    // Informational banner for non-renewing subscriptions (TDD-5606). No
    // self-service reactivation: the only action is contacting support.
    const { tenant } = storeToRefs(useAuthStore());
    const { contactSupport } = useIntercom();

    const endsAt = computed<string | null>(() => tenant.value?.subscriptionEndsAt?.format('DD/MM/YYYY') ?? null);
</script>

<template>
    <CollapsibleBanner
        class="border-b border-branding-blue-border bg-branding-blue-light text-branding-rich-black"
    >
        <template #title>
            <p class="font-bold text-base leading-tight">
                {{ $t('tenancy.tenant.non_renewing.banner.title') }}
            </p>
        </template>
        <template #body>
            <p class="leading-tight text-[13px] max-md:text-sm max-md:leading-snug">
                {{ endsAt ? $t('tenancy.tenant.non_renewing.banner.subtitle', { date: endsAt }) : $t('tenancy.tenant.non_renewing.banner.subtitle_without_date') }}
            </p>
        </template>
        <template #action>
            <button
                type="button"
                class="flex items-center gap-1.5 h-[26px] px-2.5 bg-white border border-gray-300 rounded text-gray-700 text-[11px] font-medium shadow-sm hover:bg-gray-50 transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none max-md:h-[36px] max-md:px-3 max-md:text-sm max-md:justify-center"
                @click="contactSupport()"
            >
                <i
                    class="fa-regular fa-comment text-[12px]"
                    aria-hidden="true"
                ></i>
                <span>{{ $t('actions.contact_support') }}</span>
            </button>
        </template>
    </CollapsibleBanner>
</template>
